<template>
    <b-card class="h-100"  align="left" :header-bg-variant="headerBgVariant"  footer-bg-variant="white" header-border-variant="white" body-border-variant="cdark" border-variant="white" header-class="m-0 border-0 text-left p-0" body-class="p-0 rounded " footer-class="">
        <template v-slot:header>
            <b-card-title v-if="config.templateType == '1'" class="text-white align-middle m-0  text-left p-2"  :style="`line-height:40px;font-size:1.5rem;background-repeat:no-repeat;`">
                {{config.title}}
                <!-- <form class="form-inline" v-if="config.filter">
                    <div class="form-group  w-50">
                        <select class="form-control  w-100 bg-cdark text-white" id="exampleFormControlSelect0">
                            <option>1</option>
                            <option>2</option>
                            <option>3</option>
                            <option>4</option>
                            <option>5</option>
                        </select>
                    </div>
                    <div class="form-group w-50">
                        <select class="form-control   w-100 bg-cdark text-white" id="exampleFormControlSelect1">
                            <option>1</option>
                            <option>2</option>
                            <option>3</option>
                            <option>4</option>
                            <option>5</option>
                        </select>
                    </div>
                </form> -->
            </b-card-title>
            <b-card-title v-if="(config.templateType == '4' || config.templateType == '5') && filterBuild" class="p-2">
                
                <form class="form-inline" v-if="config.filter && filterBuild">
                    <template v-for="(col,cIndex) in filtersRun">
                        <div class="form-group  mb-0 w-20" v-if="col['_colType'] == 'string'">
                            <b-input
                            class="mr-sm-2 mb-sm-0"
                            v-model="searchFormData[col.id]"
                            placeholder="请输入关键字"
                            @change="buildFilters"
                            ></b-input>
                        </div>
                        
                        <div class="form-group mb-0  w-20" v-if="col['_colType'] == 'fk' ">
                            <b-form-select
                            class="mr-sm-2 mb-sm-0"
                            v-model="searchFormData[col.id]"
                            @change="buildFilters"
                            required
                            >
                                <b-form-select-option value="全部">全部</b-form-select-option>
                                <b-form-select-option :value="item[col['_option_list_v2'].refed_col]" v-for="(item,itemIndex) in col.options">{{item[col['_option_list_v2'].key_disp_col]}}</b-form-select-option>
                            </b-form-select>
                        </div>
                        <div class="form-group mb-0  w-20" v-if="col['_colType'] == 'select' ">
                            <b-form-select
                            class="mr-sm-2 mb-sm-0"
                            v-model="searchFormData[col.id]"
                            @change="buildFilters"
                            required
                            >
                                <b-form-select-option value="全部">全部</b-form-select-option>
                                <b-form-select-option :value="item.value" v-for="(item,itemIndex) in col.options">{{item.name}}</b-form-select-option>
                            </b-form-select>
                        </div>
                    </template>
                    <div class="form-group mb-0">
                        <b-button variant="primary" @click="onListSearch"><b-icon icon="search"></b-icon>查询</b-button>
                        </div>
                    
                </form>
            </b-card-title>
        </template>
        <b-card-body class="p-0 h-100">
            <b-row  class="p-0 m-0 h-100" style="overflow:hidden;overflow-x:auto;">
                <b-col class="p-0 list-group border-0 h-100   w-100" v-if="config.templateType == '1'">
                    <div class="list-group-item list-group-item-action border-0 p-0" >
                        <div class="d-flex w-100 justify-content-between bg-cprimary p-2">
                            <h5 class="m-1 ">排名</h5>
                            <h5 class="m-1 text-center flex-grow-1">公司</h5>
                            <h5 class="m-1">政府补贴</h5>
                            <h3 class="m-1 text-danger"></h3>
                        </div>
                    </div>
                    <a  class="list-group-item list-group-item-action border-0" v-if="listData.length > 0 " v-for="(item,index) in listData">
                        <div class="d-flex w-100 justify-content-between">
                            <h5 class="m-1 font-weight-bold">{{index + 1}}</h5>
                            <h5 class="m-1 text-left flex-grow-1 overflow-hidden text-nowrap text-truncate">{{item.name}}</h5>
                            <h3 class="m-1 text-danger">{{item.subsidy_amount}}</h3>
                            <span class="m-1 h5">{{item.unit}}</span>
                        </div>
                        <!-- <p class="mb-1">Some placeholder content in a paragraph.</p>
                        <small>And some small print.</small> -->
                    </a>
                    <div v-if="listData.length == 0" style="height: 100%;" class="align-middle text-center p-3">
                        暂无数据
                    </div>
                </b-col>
                <b-col class="p-0 list-group border-0  h-100 w-100" v-if="config.templateType == '2'">
                    <a  class="list-group-item list-group-item-action border-0" v-for="(item,index) in listData"  v-if="listData.length > 0"  @click="onClickRow(item)">
                        <div class="d-flex w-100 justify-content-between">
                            <h5 class="m-1 text-center" v-if="index < 3">
                                <span class="badge badge-danger text-white">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" class="bi bi-fire" viewBox="0 0 16 16">
  <path d="M8 16c3.314 0 6-2 6-5.5 0-1.5-.5-4-2.5-6 .25 1.5-1.25 2-1.25 2C11 4 9 .5 6 0c.357 2 .5 4-2 6-1.25 1-2 2.729-2 4.5C2 14 4.686 16 8 16Zm0-1c-1.657 0-3-1-3-2.75 0-.75.25-2 1.25-3C6.125 10 7 10.5 7 10.5c-.375-1.25.5-3.25 2-3.5-.179 1-.25 2 1 3 .625.5 1 1.364 1 2.25C11 14 9.657 15 8 15Z"/>
</svg>
                                    HOT
                                </span>
                            </h5>

                            <h5 class="m-1 text-left flex-grow-1 overflow-hidden text-nowrap text-truncate">{{item.policy_title}}</h5>
                            <h5 class="m-1 bd-highlight">
                                <span class="badge badge-pill badge-primary" style="width: 64px;" v-if="item.progress_state !== '已结束'">
                                    {{getDays(item.end_date) }}
                                </span>
                                <span class="badge badge-pill badge-danger" style="width: 64px;" v-if="item.progress_state == '已结束'">
                                    {{item.progress_state}}
                                </span>
                            </h5>
                        </div>
                        <!-- <p class="mb-1">Some placeholder content in a paragraph.</p>
                        <small>And some small print.</small> -->
                    </a>
                    
                    <div v-if="listData.length == 0" style="height: 100%;" class="align-middle text-center p-3">
                        暂无数据
                    </div>
                </b-col>
                <b-col class="p-0 list-group border-0" md="12" v-if="config.templateType == '3'">
                    <a  class="list-group-item list-group-item-action border-0" v-for="(item,index) in listData" @click="onClickRow(item)">
                        <div class="d-flex w-100 justify-content-between">
                            <div style="width:calc(100% - 90px)">
                                <h4 class="mb-1 text-dark font-weight-bold " >{{new Date(item.create_time).toLocaleDateString()}}</h4>
                                <h5 class="mb-1 text-dark" style="overflow:hidden; text-overflow:ellipsis;display:-webkit-box; -webkit-box-orient:vertical;-webkit-line-clamp:2; ">{{item.title}}</h5>
                                <!-- <small>{{item.title}}</small> -->
                            </div>
                            

                            <img :src="`https://api.100xsys.cn/file/download?fileNo=${item.icon_image}&bx_auth_ticket=${token}`" class="rounded float-right mr-1" style="width: 90px;height: 90px;" alt="...">
                        </div>
                    </a>
                </b-col>
                <b-col class="p-0 list-group border-0 h-100 w-100" v-if="config.templateType == '4'">
                    <div class="list-group-item list-group-item-action border-0 p-0" >
                        <div class="d-flex w-100 justify-content-between bg-cprimary p-2">
                            <h5 class="m-1  flex-grow-1 pl-3">政策</h5>
                            <h5 class="m-1 text-center"   style="width: 64px;">部门</h5>
                            <h5 class="m-1 text-center"   style="width: 100px;">截止天数</h5>
                        </div>
                    </div>
                    <a @click="onClickRow(item)" class="list-group-item list-group-item-action border-0" v-for="(item,index) in listData"  v-if="listData.length > 0">
                        <div class="d-flex w-100 justify-content-between">
                            <h5 class="m-1 text-left flex-grow-1 overflow-hidden text-nowrap text-truncate" style="width: 60%;">
                                <span class="badge badge-danger text-white" v-if="index < 3 && config.serviceName == 'srvcosvc_policy_info_user_hot_select'">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" class="bi bi-fire" viewBox="0 0 16 16">
                                    <path d="M8 16c3.314 0 6-2 6-5.5 0-1.5-.5-4-2.5-6 .25 1.5-1.25 2-1.25 2C11 4 9 .5 6 0c.357 2 .5 4-2 6-1.25 1-2 2.729-2 4.5C2 14 4.686 16 8 16Zm0-1c-1.657 0-3-1-3-2.75 0-.75.25-2 1.25-3C6.125 10 7 10.5 7 10.5c-.375-1.25.5-3.25 2-3.5-.179 1-.25 2 1 3 .625.5 1 1.364 1 2.25C11 14 9.657 15 8 15Z"/>
                                    </svg>
                                    HOT
                                </span>
                                {{item.policy_title}}
                            </h5>
                            <h5 class="m-1 text-right"  style="width: 64px;">{{item.policy_sources_name}}</h5>
                            <h5 class="m-1 bd-highlight text-center"  style="width: 100px;">
                                <span class="badge badge-pill badge-primary" style="width: 64px;" v-if="item.progress_state !== '已结束'">
                                    {{getDays(item.end_date) }}
                                </span>
                                <span class="badge badge-pill badge-danger" style="width: 64px;" v-if="item.progress_state == '已结束'">
                                    {{item.progress_state}}
                                </span>
                            </h5>
                        </div>
                        <!-- <p class="mb-1">Some placeholder content in a paragraph.</p>
                        <small>And some small print.</small> -->
                    </a>
                    <div v-if="listData.length == 0" style="height: 100%;" class="align-middle text-center p-3">
                        暂无数据
                    </div>
                </b-col>
                <b-col class="p-0 list-group border-0 h-100" v-if="config.templateType == '5'">
                    <b-row class="p-0 m-0"   v-if="listData.length > 0">
                        <b-col sm="6"  md="4" v-for="(item,index) in listData" class="p-3 m-0 d-none d-sm-block" >
                            <b-card class="border-0 rounded-lg" @click="onClickRow(item,)" style="overflow: hidden;"  body-border-variant="white" header-border-variant="white" footer-class="border border-0 p-0"  header-class="border border-0  bg-cgray"  body-class="border border-0 bg-cgray"  :img-src="item['_src'][0]" img-alt="Image" img-top >
                                <template v-slot:header>
                                    <b-card-title  class="m-0"  style="line-height:24px;font-size:22px;height:72px;overflow: hidden;">
                                        {{item.title}}
                                    </b-card-title>
                                </template>
                                <b-card-text>
                                    <span>发布时间：{{ item.create_time }}</span>
                                </b-card-text>
                                <b-card-text>
                                    <span>发布人：{{ item.create_user }}</span>
                                </b-card-text>
                            </b-card>
                        </b-col>
                        <b-col sm="6"  md="4" v-for="(item,index) in listData" class="p-3 m-0  d-block d-xs-none" >
                            <b-card class="border-0 rounded-lg" @click="onClickRow(item,)" style="overflow: hidden;"  body-border-variant="white" header-border-variant="white" footer-class="border border-0 p-0"  header-class="border border-0  bg-cgray"  body-class="border border-0 bg-cgray"   img-alt="Image" img-top >
                                <template v-slot:header>
                                    <b-card-title  class="m-0"  style="line-height:24px;font-size:22px;height:72px;overflow: hidden;">
                                        {{item.title}}
                                    </b-card-title>
                                </template>
                                <b-card-text>
                                    <span>发布时间：{{ item.create_time }}</span>
                                </b-card-text>
                                <!-- <b-card-text>
                                    <span>发布人：{{ item.create_user }}</span>
                                </b-card-text> -->
                            </b-card>
                        </b-col>
                    </b-row>
                    <div v-if="listData.length == 0" style="height: 100%;" class="align-middle text-center p-3">
                        暂无数据
                    </div>
                </b-col>
                <b-col class="p-0 list-group border-0 h-100 w-100" v-if="config.templateType == '6'">
                    <!-- <div class="list-group-item list-group-item-action border-0 p-0" >
                        <div class="d-flex w-100 justify-content-between bg-cprimary p-2">
                            <h5 class="m-1  pl-3" :class="(hIndex + 1) == headers.length ? `text-right` : `text-left`" v-for="(header,hIndex) in headers">{{header.label}}</h5>
                        </div>
                    </div>
                    <a @click="onClickRow(item)" class="list-group-item list-group-item-action border-0" v-for="(item,index) in listData"  v-if="listData.length > 0">
                        <div class="d-flex w-100 justify-content-between">
                            <h5 class="m-1" :class="(hIndex + 1) == headers.length ? `text-right` : `text-left`"  v-for="(header,hIndex) in headers">{{item[header.columns]}}</h5>
                        </div>
                    </a> -->
                    <b-table striped hover table-variant="" head-variant="light" :items="listData" :fields="headers" >
                        <template v-slot:head(item.key)="data" v-for="(item,i) in headers">
                            <span class="text-cdark">{{ data.label.toUpperCase() }}</span>
                        </template>
                        <!-- <template v-slot:head(key)="data">
                            <span class="text-cdark">{{ data.label.toUpperCase() }}</span>
                        </template> -->
                    </b-table>
                    <div v-if="listData.length == 0" style="height: 100%;" class="align-middle text-center p-3">
                        暂无数据
                    </div>
                </b-col>
            </b-row>
        </b-card-body>
        <template v-slot:footer >
            <b-row  class=" m-0  d-flex justify-content-end" v-if="config.footer == 'more' && listData.length > 0">
                <button type="button" class="btn btn-outline-light text-reset" @click="onMore">查看更多 <b-icon icon="chevron-right"></b-icon></button>
            </b-row>
            <b-row  class="m-0  text-center d-flex justify-content-center" v-if="config.footer == 'pagination'">
                <b-pagination
                v-model="page.pageNo"
                :total-rows="totalRows"
                :per-page="perPage"
                aria-controls="my-table"
                ></b-pagination>
            </b-row>
        </template>
    </b-card>
  </template>
  
  <script>
  
import store from '@/store'
  import qrCode from '@/assets/qrCode.png'
  import { getXianZhuang,getJianBao,getListData,getV2 } from '@/api/api.js'
  export default {
    name: 'list',
    props: {
        footer:{
            type:String,
            default(){
                return 'more' // pagination
            }
        },
        type:{
            type:String,
            default(){
                return 'text'  // text   map   list
            }
        },
        config:{
            type:[Object,Array],
            default(){
                return null
             
            }
        },
        title:{
            type:String,
            default(){
                return ''
            }
        },
        app:{
            type:String,
            default(){
                return ''
            }
        }
    },
    computed:{
        filterFormRun(){
            let form = this.bxDeepClone(this.searchFormData)
            return form
        },
        filterBuild(){
            let filters = this.bxDeepClone(this.filtersRun)
                let isLoad = []
            if(this.config.filter && filters.length > 0){
                for(let f of filters){
                    if(f['_colType'] == 'fk' && f['options'].length > 0){
                        isLoad.push(true)
                    }
                    if(f['_colType'] == 'string'){
                        isLoad.push(true)
                    }
                }
            }
            return isLoad.length > 0
        },
        isGetV2(){
            let filters = this.config.filters
            let isGet = false
            if(filters && filters.length > 0){
                for(let col of filters){
                    if( typeof col == 'object' && col.type == 'v2Col'){
                        isGet = true
                    }
                }
            }
            if(this.config.hasOwnProperty('columns') && this.config.columns.length > 0){
                isGet = true
            }
            return isGet
        },
        headers(){
            let cols = []
            let headers = []
            if(this.isGetV2 && this.v2){
                cols = this.config.columns
                headers = this.v2.srv_cols
                headers = headers.filter(item =>{
                    if(cols.indexOf(item.columns) !== -1){
                        return true
                    }
                })
                headers = headers.map(item =>{
                    item['key'] = item.columns
                    return item
                })
            }
            return headers
        },
        totalRows(){
            let total = 0
            total = this.page.total
            return total
        },
        perPage(){
            let perPage = this.page.rownumber
            return perPage
        },
        
        pathRun(){
            return this.$route.path
        },
        headerBgVariant(){
            let bg = 'cdark'
            let serviceName = this.config.serviceName
            switch (serviceName) {
                case 'srvcosvc_policy_info_user_visitor_select':
                bg = ''
                    break;
                case 'srvdaq_cms_content_jianbao_select':
                bg = ''
                    break;
                case 'srvcosvc_policy_info_user_hot_select':
                bg = ''
                    break;
            
                default:
                    break;
            }
            return bg
        },
        pageRun(){
            let page = this.bxDeepClone(this.page) 
            return page
        },
        templateType(){
            let tempID = this.config.templateType || '1'
            return tempID

        },
        req(){
            let req = {
                "serviceName":this.config.serviceName,
                "colNames":["*"],
                "condition":[],
                "relation_condition":{},
                "page":this.page,
                "order":[],
                "draft":false
            }
            let searchVal = this.$route.query.val || ''
            if(this.config.hasOwnProperty('order')){
                req.order = this.config.order
            }
            if(this.config.hasOwnProperty('condition')){
                req.condition = this.config.condition
            }
            switch (req.serviceName) {
                case 'srvcosvc_policy_info_user_visitor_select':
                    if(this.config.filter && this.filtersRun && this.filtersRun.length > 0){
                        let formData = this.bxDeepClone(this.searchFormData) 
                    console.log(formData)
                        let fData = []
                        for(let filter of this.filtersRun){
                            let cols = filter.colNames
                                if(cols.length > 0){
                                    let colsData = {
                                        "relation": "OR",
                                        "data": []
                                    }
                                    for(let col of cols){
                                        if(formData[filter.id]&& formData[filter.id] !== '全部'){
                                                colsData.data.push({
                                                "colName": col,
                                                "value":formData[filter.id],
                                                "ruleType": filter.ruleType
                                            })
                                        }
                                    }
                                    if(colsData.data.length > 0 ){
                                        fData.push(colsData)
                                    }
                                }else{
                                    if(formData[filter.id]&& formData[filter.id] !== '全部'){
                                        fData.push({
                                            "colName": col,
                                            "value":formData[filter.id],
                                            "ruleType": filter.ruleType
                                        })
                                    }
                                }
                            
                        }
                        
                        req.relation_condition = {
                            "relation": "AND",
                            "data": fData
                        }
                    }
                    break;
                case 'srvdaq_cms_content_jianbao_select':
                    if(this.config.filter && this.filtersRun && this.filtersRun.length > 0){
                        let formData = this.bxDeepClone(this.searchFormData) 
                    // console.log(formData)
                        let fData = []
                        for(let filter of this.filtersRun){
                            let cols = filter.colNames
                                if(cols.length > 0){
                                    let colsData = {
                                        "relation": "OR",
                                        "data": []
                                    }
                                    for(let col of cols){
                                        if(formData[filter.id] && formData[filter.id] !== '全部'){
                                                colsData.data.push({
                                                "colName": col,
                                                "value":formData[filter.id],
                                                "ruleType": filter.ruleType
                                            })
                                        }
                                    }
                                    if(colsData.data.length > 0 ){
                                        fData.push(colsData)
                                    }
                                }else{
                                    if(formData[filter.id] && formData[filter.id] !== '全部'){
                                        fData.push({
                                            "colName": col,
                                            "value":formData[filter.id],
                                            "ruleType": filter.ruleType
                                        })
                                    }
                                }
                            
                        }
                        
                        req.relation_condition = {
                            "relation": "AND",
                            "data": fData
                        }
                    }
                    break;
            
                default:
                    break;
            }
            switch (this.templateType) {
                case '1':
                req['order']=[{
                    colName: "rank",
                    orderType: "asc"
                }]
                    break;
            
                default:
                    break;
            }
            return req
        }
    },
    mounted(){
        this.getData() 
        
    },
    created(){
        if(this.isGetV2){
            this.getListV2()
        }else if(!this.isGetV2 && this.config.filters && this.config.filters.length > 0){
            this.buildFilters()
        }
    },
    data() {
      return {
        qrCode:qrCode,
        provinceName:"",
        listData:[],
        token:store.getters.token,
        page:{
        "total": 0,
        "pageNo": 1,
        "rownumber": this.config.pageRowNumber || 10
        },
        nextPaged:false,
        upPaged:false,
        searchFormData:{
            searchVal:""
        },
        v2:null,
        filtersRun:[]
      }
    },
    methods: {
        buildFilters(){
            let isFilter =  this.filtersRun.length > 0 ? this.bxDeepClone(this.filtersRun) : this.bxDeepClone(this.config.filter) 
            if(!isFilter){
                return
            }
            let filters = this.config.filters
            let v2Cols = null
            if(this.isGetV2 && this.v2){
                v2Cols = this.v2.srv_cols
            }
            if(filters && filters.length > 0){
                filters = filters
                for(let col of filters){
                    col['value'] = ''
                   
                    if(col.hasOwnProperty('colNames') &&  col.colNames.length > 0){
                        let colNames = col.colNames
                        col['id'] = col.colNames.join('@')
                        if(!this.searchFormData.hasOwnProperty(col['id'])){
                            this.searchFormData[col['id']] = this.$route.query[col['id']] || ''
                        }
                            
                        for(let colName of colNames){
                            // 循环字段名
                            if( typeof col == 'object' && col.type == 'v2Col'&& v2Cols){
                                // 来源v2的查询条件
                                let srvCol = v2Cols.filter(item => item.columns == colName)
                                col['_srv_col'] = srvCol.length > 0 ? srvCol[0] : null
                                
                                col['_colType'] = col['_srv_col'].bx_col_type.toLowerCase() !== 'string' ? col['_srv_col'].bx_col_type.toLowerCase() :  col['_srv_col'].col_type.toLowerCase() !== 'string' ? col['_srv_col'].col_type.toLowerCase() : 'string'
                                if(col['_colType'] == 'fk'){
                                    col['options'] = []
                                    col['_option_list_v2'] = col['_srv_col'].option_list_v2
                                    if(!col['options'] || col['options'].length == 0 ||  col.id == 'city'){
                                        col['options'] = this.getOptions(col)
                                       
                                    }
                                    
                                    
                                    this.searchFormData[col['id']] = this.searchFormData[col['id']] ?  this.searchFormData[col['id']] : '全部'
                                    // let isChecked = col['options'].filter(item => item[])
                                }
                            }else  if( typeof col == 'object' && col.type == 'select' && col.options.length > 0){
                                col['_colType'] = col.type
                                col['_srv_col'] =  null
                                
                                this.searchFormData[col['id']] = this.searchFormData[col['id']] ?  this.searchFormData[col['id']] : '全部'
                            }else if( typeof col == 'object' && col.type !== 'v2Col'){
                                col['_colType'] = col.type
                                col['_srv_col'] =  null
                            }else if( typeof col == 'string' && col.type !== 'v2Col'){
                                col['_colType'] = col.type
                                col['_srv_col'] =  null
                            }
                        }

                    }
                    
                    
                }
            }
            if(filters){
                this.filtersRun = filters.map(item => item)
            }
            
            // return filters
        },
        async getOptions(filter,index){
            let options = filter['_option_list_v2']
            let app = options.srv_app
            let serviceName = options.serviceName
            let conds = options.conditions ? this.bxDeepClone(options.conditions) : []
            let conditionBuild = true
            if(conds.length > 0){
                for(let cond of conds){
                    if(cond.value.indexOf("'") !== -1){
                        cond.value = cond.value.replace("'","")
                    }else if(cond.value.indexOf('data.') !== -1){
                        let data = this.searchFormData
                        cond.value = eval(`${cond.value}`)
                        console.log('eval',cond.value)
                        if(!cond.value){
                            conditionBuild = false
                        }
                        
                    }
                }
            }
            let req = {
                "serviceName":serviceName,
                "colNames":["*"],
                "condition": this.bxDeepClone(conds),
                "relation_condition":{"relation":"AND","data":[]},
                "page":{"total":0,"pageNo":1,"rownumber":999},
                "order":[]
            }
            let data = []
            // console.log(req)
            if(conditionBuild){
                await getListData(req,app,serviceName).then((res) =>{
                    // console.log('----',res)
                    data =  res.data
                    
                    for(let f of this.filtersRun){
                        if(f.id == filter.id){
                            this.$set(f,'options',data)
                            // f['options'] = data.map(item => item)
                        }
                    }
                })
            }
           
            return data
        },
        getListV2(){
            let req = {
                    "serviceName":"srvsys_service_columnex_v2_select",
                    "colNames":["*"],
                    "condition":[
                            {"colName":"service_name",
                            "value":this.config.serviceName,
                            "ruleType":"eq"
                        },{
                            "colName":"use_type",
                            "value":"list",
                            "ruleType":"eq"
                        }
                    ],
                    "order":[{"colName":"seq","orderType":"asc"}]
            }
            getV2(req,this.config.app).then((res) =>{
                // console.log('----',res)
                this.v2 = this.bxDeepClone(res.data) 
                // this.$set(this,'page',this.bxDeepClone(res.page))

                this.buildFilters()
            })
        },
        onListSearch(){
            this.page.pageNo = 1
            this.getData()
        },
        getDays(e){
            // console.log(new Date(e).getTime(),new Date().getTime(),(new Date(e).getTime() - new Date().getTime()))
            let days = ((new Date(e).getTime() - new Date().getTime()) / 1000 / 60  / 60 / 24) > 0 ? ((new Date(e).getTime() - new Date().getTime()) / 1000 / 60 / 60 /24) : 0 
            return Math.ceil(days) + '天'
        },
        onMore(){
            let service = this.req.serviceName
            let path = ''
            switch (service) {
                case 'srvcosvc_policy_info_user_visitor_select':
                    path = '/policy'
                break;
                case 'srvdaq_cms_content_jianbao_select':
                    path = '/briefing'
                break;
                case 'srvcosvc_policy_subsidy_select':
                    path = '/buTie'
                break;
                default:
                    break;
            }
            let routeData = this.$router.resolve(path)
            window.open(routeData.href, '_blank');
            

        },
        onClickRow(e){
            console.log(e)
            let service = this.req.serviceName
            let path = ''
            switch (service) {
                case 'srvcosvc_policy_info_user_visitor_select':
                    path = '/policy'
                    this.$router.push({
                        path:`${path}Detail/${encodeURIComponent(JSON.stringify(e))}`
                    })
                        break;
                case 'srvdaq_cms_content_jianbao_select':
                    path = '/briefing'
                    this.$router.push({
                        path:`${path}Detail/${encodeURIComponent(JSON.stringify(e))}`
                    })
                    // let routeData = this.$router.resolve(`${path}Detail/${encodeURIComponent(JSON.stringify(e))}`);
                    // window.open(routeData.href, '_blank');
                    break;
                    
                default:
                    break;
            }
            
            // this.$router.push({
            //     path:`${path}Detail/${encodeURIComponent(JSON.stringify(e))}`
            // })
        },

        getData(){
            let req = this.bxDeepClone(this.req) 
            let tempID = this.config.templateType
            // console.log('查询',req)
            switch (tempID) {
                case '1':
                    getListData(req,this.config.app,this.config.serviceName).then((res) =>{
                        // console.log('----',res)
                        this.listData = res.data
                        this.$set(this,'page',this.bxDeepClone(res.page))
                    })
                    break;
                case '2':
                    getListData(req,this.config.app,this.config.serviceName).then((res) =>{
                        // console.log('----',res)
                        this.listData = res.data
                        this.$set(this,'page',this.bxDeepClone(res.page))
                    })
                    break;
                case '3':
                    getJianBao(req).then((res) =>{
                        // console.log('----',res)
                        this.listData = res.data
                        this.$set(this,'page',this.bxDeepClone(res.page))
                    })
                    break;
                    
                case '4':
                    getListData(req,this.config.app,this.config.serviceName).then((res) =>{
                        // console.log('----',res)
                        this.listData = res.data
                        this.$set(this,'page',this.bxDeepClone(res.page))
                        // this.page = 
                    })
                    break;
            
                default:
                    getListData(req,this.config.app,this.config.serviceName).then((res) =>{
                        // console.log('----',res)
                        this.listData = this.bxDeepClone(res.data) 
                        this.listData = this.listData.map(item =>{
                            if(item.hasOwnProperty('content')){
                                // 截取富文本img方法
                                item['_src'] = this.reHtmlImgSrc(item.content)
					
                            }
                            return item
                        })
                        this.$set(this,'page',this.bxDeepClone(res.page))
                    })
                    break;
            }
            let allLen = (this.page.pageNo & this.page.rownumber) < this.page.total
            if(allLen){
                this.nextPaged = true
            }else{
                this.nextPaged = false
            }
        }
        
    },
    watch:{
        "pageRun":{
            deep:true,
            handler:function(nval,oval){
                // console.log(nval,oval)
                if(nval.pageNo !== oval.pageNo){
                    this.getData()
                }
            }
        },
        "filterFormRun":{
            deep:true,
            immediate:true,
            handler:function(nval,oval){
                // console.log('搜索条件更新',nval,oval)
                // this.buildFilters()
            }
        },
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>

  </style>
  